// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDzIrG9YgQXipqBvBTJ6LJVY951WpAXVr4",
    authDomain: "radnerus-blog.firebaseapp.com",
    databaseURL: "https://radnerus-blog.firebaseio.com",
    projectId: "radnerus-blog",
    storageBucket: "radnerus-blog.appspot.com",
    messagingSenderId: "649340031542",
    appId: "1:649340031542:web:5ffec360e522d88755fe97",
    measurementId: "G-F4B6ZX4NT7"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
